import { FormattedMessage } from "react-intl";

export const pageInfo = {
   pageName: <FormattedMessage id="tournaments.pageName.title" tagName="span" />,
   filter: false,
   addBtn: <FormattedMessage id="tournaments.btn.addBtn" tagName="span" />,
   periodContainer: true,
   toROUTER: 'createTournament',
   pro: true,
   live: true,
}
